import { Container, Content, Overlay } from './styles'
import { FiAlertCircle } from 'react-icons/fi'
import { useAsyncFn } from 'react-use'
import { toast } from 'react-toastify'
import { TSummaryQuestion } from '../QuestionsSummary/types'
import { DELETE_QUESTION_BOOK_ITEM } from 'pages/QuestionBook/services'

interface IProps {
  isOpen: boolean
  onClose(): void

  question: TSummaryQuestion
  position: number

  onDelete(question: TSummaryQuestion): void
}

const DeleteModal = (props: IProps) => {
  const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation()

  const [state, post] = useAsyncFn(async () => {
    try {
      await DELETE_QUESTION_BOOK_ITEM(props.question.questionBook._id, props.question._id)

      props.onDelete(props.question)

      toast.success('Questão excluída com sucesso!')
    } catch {
      toast.error('Erro ao excluir questão')
    }
  }, null)

  if (!props.isOpen) return null

  return (
    <Overlay onClick={props.onClose}>
      <Container onClick={stopPropagation}>
        <Content>
          <FiAlertCircle className="alert-icon" />

          <p className="title">
            Tem certeza que deseja remover <br />
            do caderno a questão abaixo?
          </p>

          <p className="short-text">
            <b>Questão {props.position} - </b>
            <span
              ref={(node) => {
                if (node) {
                  node.innerHTML = node.textContent
                }
              }}
              dangerouslySetInnerHTML={{
                __html: props.question.text.replace(/\\[n|r|t]/g, '<br />'),
              }}
            />
          </p>

          <div className="buttons">
            <button className="delete" disabled={state.loading} onClick={post}>
              Remover
            </button>
            <button className="cancel" onClick={props.onClose}>
              Cancelar
            </button>
          </div>
        </Content>
      </Container>
    </Overlay>
  )
}

export default DeleteModal
